import { useNavigate } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { useI18n } from '@ywwwtseng/react-kit';
import { TokenIcon } from './TokenIcon';
import type { SelectToken } from '@/types';
import { displayAmount } from '@/utils/token';
import { useTokenPrice } from '@/hooks/useTokenPrice';
import { useUserBalance } from '@/hooks/useUserBalance';

interface TokenBalanceProps {
  token: SelectToken;
}

export function TokenBalance({ token }: TokenBalanceProps) {
  const navigate = useNavigate();
  const { t } = useI18n();
  const { formatted } = useTokenPrice(token.id);
  const balance = useUserBalance(token);

  return (
    <div
      key={token.id}
      className="h-stack w-full gap-2 px-1 py-1.5 cursor-pointer"
      onClick={() => {
        navigate('Token', { params: { token_id: token.id } });
      }}
    >
      <TokenIcon token={token} width={32} height={32} />
      <div className="v-stack w-full !items-start">
        <Typography size="3" weight={500}>
          {token.symbol}
        </Typography>
        {formatted && (
          <Typography size="1" color="#777777">
            ${formatted}
          </Typography>
        )}
      </div>
      <div className="v-stack w-full ml-auto !items-end">
        <Typography size="3" weight={500}>
          {displayAmount(balance.totalFormatted, { showTinyAmount: false })}
          {/* {balance.hasLocked && (
            t('common.balance_locked_hint', {
              locked: balance.lockedFormatted,
            })
          )} */}
        </Typography>

        {balance.price && (
          <Typography size="1" color="#777777">
            {`$${balance.price}`}
          </Typography>
        )}
      </div>
    </div>
  );
}
